import { useCurrencyFormatter } from "./useCurrencyFormatter";
import { Text } from "@chakra-ui/react";

/**
 * @typedef {Object} MoneyProps
 * @property {(Number|string)} value Amount in the lowest denomination for the currency
 * @property {string} currency
 * @property {CurrencyDisplay} [currencyDisplay] Optional format for the display
 * @property {...any} [textProps]
 */

/**
 * Formats and renders the currency value as a localized string inside an HTML <data> element,
 * adding the value and currency code as attributes, and accepting Chakra text props for
 * optional styling.
 *
 * @param {MoneyProps} props
 * @returns {JSX.Element}
 */
const FormattedMoney = ({ value, currency, currencyDisplay, ...textProps }) => {
  try {
    const formatter = useCurrencyFormatter(currency, currencyDisplay);
    if (!Number.isInteger(value)) {
      return null;
    }
    return (
      <Text as="data" value={value} data-currency={currency} {...textProps}>
        {formatter(value)}
      </Text>
    );
  } catch (e) {
    console.error("FormattedMoney: could not format money value", e);
    return null;
  }
};

export default FormattedMoney;
